import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { HeaderComponent } from '../shared/header/header.component';
import { MainMenuComponent } from '../shared/main-menu/main-menu.component';

@Component({
  selector: 'tr-main-template',
  imports: [RouterOutlet, HeaderComponent, MainMenuComponent],
  templateUrl: './main-template.component.html',
  styleUrl: './main-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainTemplateComponent {}
